import { writable } from "svelte/store";

export const user_sso_id = writable<string>('');
export const token_sso_id = writable<string>('');